import { ProductMigrationDetails } from 'types/MigrationsDetails'
import { fetchUcs } from './fetchUcs'

export const getProductMigrationDetails = (accountKey: string): Promise<ProductMigrationDetails> =>
  fetchUcs({
    path: `v2/migration/${accountKey}`,
  })
